var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { tourShareUrl } from '../../../../common/tour-link';
import { useToast } from '../../../../contexts/toast';
// Hands a visitor the tour's link to pass on: its custom link when it has one, so nobody shares the
// address bar's id. A phone offers its own share sheet; anything else copies the link.
const TourShareButton = (props) => {
    const toast = useToast();
    const share = () => __awaiter(void 0, void 0, void 0, function* () {
        const url = tourShareUrl(props.tour);
        if (typeof navigator.share === 'function') {
            // Closing the sheet without sharing rejects, which is nothing to report.
            yield navigator.share({ title: props.tour.title, url }).catch(() => undefined);
            return;
        }
        yield navigator.clipboard.writeText(url);
        toast.success('Link copied');
    });
    return _jsx(_Fragment, { children: _jsxs("button", { type: "button", className: "btn tour-cta gap-2", onClick: share, children: [_jsx("i", { className: "bi bi-share", "aria-hidden": "true" }), "Share"] }) });
};
export default TourShareButton;
